import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import theme from "./theme";
import Dashboard from "./pages/Dashboard";
import JobRequirements from "./pages/JobRequirements";
import Pipeline from "./pages/Pipeline";
import MyDay from "./pages/MyDay";
import Candidates from "./pages/Candidates";
import Users from "./pages/Users";
import Clients from "./pages/Clients";
import Settings from "./pages/Settings";
import Login from "./pages/Login";
import Register from "./pages/Register";
import BulkUpload from "./pages/BulkUpload";
import Tickets from "./pages/Tickets";
import ClientDashboard from "./pages/ClientDashboard";
import ClientPositions from "./pages/ClientPositions";
import ClientCandidates from "./pages/ClientCandidates";
import AppLayout from "./components/AppLayout";
import { ToastProvider } from "./components/Toast";
import { isClient } from "./auth/auth";
import "./index.css";

// Staff area (admin/manager/recruiter/staff). If a CLIENT lands here,
// bounce them to their own dashboard so they never see staff pages.
function StaffOnly() {
  if (isClient()) return <Navigate to="/client" replace />;
  return <Outlet />;
}

// Client area. If a non-client lands here, send them to the main dashboard.
function ClientOnly() {
  if (!isClient()) return <Navigate to="/" replace />;
  return <Outlet />;
}

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ToastProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            <Route element={<AppLayout />}>
              {/* Client (SPOC) portal — read only, scoped to their company */}
              <Route element={<ClientOnly />}>
                <Route path="/client" element={<ClientDashboard />} />
                <Route path="/client/positions" element={<ClientPositions />} />
                <Route
                  path="/client/candidates"
                  element={<ClientCandidates />}
                />
              </Route>

              {/* Tickets + Settings — available to BOTH staff and clients */}
              <Route path="/tickets" element={<Tickets />} />
              <Route path="/settings" element={<Settings />} />

              {/* Staff portal */}
              <Route element={<StaffOnly />}>
                <Route path="/" element={<Dashboard />} />
                <Route path="/jobs" element={<JobRequirements />} />
                <Route path="/candidates" element={<Candidates />} />
                <Route path="/pipeline" element={<Pipeline />} />
                <Route path="/my-day" element={<MyDay />} />
                <Route path="/users" element={<Users />} />
                <Route path="/clients" element={<Clients />} />
                <Route path="/bulk-upload" element={<BulkUpload />} />
              </Route>
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </ToastProvider>
    </ThemeProvider>
  );
}
